var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2965.7 702.5",
    enableBackground: "new 0 0 2965.7 702.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1b3e87",
    d: "M659.9,123L739,0.1H69.1C50,0.1,32.7,7.3,19.6,20.3C7.1,32.7,0,49.3,0,66.9v568.6c0,17.6,7.1,34.2,19.6,46.7 C32.7,695,50,702.4,69.1,702.4h590.9l79-122.9H134.2V415.8h445.5l78.8-123H134.2V123H659.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b3e87",
    d: "M971.3,0H838v635.9c0,17.6,7,34,19.4,46.5c13,12.8,30.3,20,49.1,20h607.6l78.5-122.2H971.3V0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1b3e87",
    points: "2254.4,0.1 1389,0.1 1310.5,122.2 1713.5,122.2 1713.5,702.5 1846.9,702.5 1846.9,122.2 2175.8,122.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b3e87",
    d: "M2544.3,44.1c-18-26.2-48.2-41.8-81.2-41.8c-33.6,0-64.3,16.2-82.1,42.9l-419.8,657.1h157.1l345-547.2l187.8,302.7h-355.6 l78.6,122.2h360.3l73.8,122.3h157.3L2544.3,44.1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf69e16f4f96e263125d52caa0722672.svg";
export { ForwardRef as ReactComponent };